import React, { Fragment, useState } from "react";
import { getMarkup, shouldCheckboxOptionDisabled } from "../../../utils/Utils";
import Checkbox from "../form-element/CheckboxOption";
import './CheckboxForEditAssessment.scss';

const CheckboxForEditAssessment = ({
                      isFocused,
                      label,
                      question,
                      checkedOption,
                      options,
                      onChange,
                      errorMessage,
                      cssStyle,
                      error,
                      clickOnThumbnail,
                      checkedOptionsIds,
                      disabled = false
                  }) => {
    const onChangeCheckbox = (
        e,
        answerId,
        answerText,
        index,
        title,
        description
    ) => {
        if(disabled) return;

        let isChecked = e.target.checked;

        onChange &&
        onChange({
            question: question,
            answerId: answerId,
            answerText: answerText,
            answerIndex: index,
            title: title,
            description: description,
            checked: !isChecked,
        });
    };

    const getFocusColor = () => {
        if (isFocused) {
            return { border: "1px solid #1176B4" };
        }
    };

    const isCheckedCurrentOption = (optionId) => {
        return checkedOptionsIds.includes(optionId);
    }


    const [tooltipVisible, setTooltipVisible] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

    const handleMouseEnter = (e, optionId) => {
        const rect = e.target.getBoundingClientRect();
        setTooltipPosition({
            top: rect.top - 30,
            left: rect.left + rect.width / 2
        });
        setTooltipVisible(optionId);
    };

    const handleMouseLeave = () => {
        setTooltipVisible(null);
    };

    return (
        <>
            {cssStyle === "row" && (
                <div className="form-group checkbox-for-edit-assessment--row" style={getFocusColor()}>
                    <label
                        id={`cc-question-${question.questionId}`}
                        className="checkbox-for-edit-assessment__label"
                    >
                        {label}
                    </label>
                    <div className="checkbox-for-edit-assessment__options">
                        <div className="checkbox-for-edit-assessment__options-container">
                            {options &&
                                options.length > 0 &&
                                options.map((option, index) => {
                                    const optionId = `btn-${question.questionId}-${option.id}`;
                                    return (
                                        <div
                                            key={option.id}
                                            className="checkbox-for-edit-assessment__option-wrapper"
                                            onMouseEnter={(e) => option.title && handleMouseEnter(e, option.id)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <Checkbox.OptionItem
                                                isChecked={isCheckedCurrentOption(option.id)}
                                                onClick={(e) =>
                                                    onChangeCheckbox(
                                                        e,
                                                        option.id,
                                                        option.name,
                                                        index,
                                                        option.title,
                                                        option.description
                                                    )
                                                }
                                                label={option.name}
                                                className={`edit-assessment-button edit-assessment-checkbox${
                                                    isCheckedCurrentOption(option?.id) ? ' selected-button' : ''
                                                } ${disabled && !isCheckedCurrentOption(option?.id) ? ' pointer-none ' : ''}`}
                                                style={{ pointerEvents: disabled ? 'none' : 'auto' }}
                                                iconClassName="checkbox-for-edit-assessment__icon"
                                                disabled={disabled ? (isCheckedCurrentOption(option.id) ? false : true) : shouldCheckboxOptionDisabled(question?.singleSelectAnswerId, question?.answerList, option.id)}
                                                id={optionId}
                                            />
                                            {option.title && tooltipVisible === option.id && (
                                                <div
                                                    className="checkbox-for-edit-assessment__tooltip"
                                                    style={{
                                                        top: `${tooltipPosition.top}px`,
                                                        left: `${tooltipPosition.left}px`,
                                                        position: 'fixed',
                                                        zIndex: 1000
                                                    }}
                                                >
                                                    <strong>{option.title}</strong>
                                                    <br />
                                                    {option.description}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                        </div>
                        {errorMessage && (
                            <div className="checkbox-for-edit-assessment__error-message">
                                This field is required
                            </div>
                        )}
                        {error && error.questionId === question.questionId && (
                            <span className="checkbox-for-edit-assessment__error-text">
                                * {error.message}
                            </span>
                        )}
                    </div>
                </div>
            )}
            {cssStyle === "column" && (
                <div className="form-group checkbox-for-edit-assessment--column" style={getFocusColor()}>
                    <div className="checkbox-for-edit-assessment__container">
                        <div>
                            <label
                                id={`cc-question-${question.questionId}`}
                                className="checkbox-for-edit-assessment__label--large"
                                dangerouslySetInnerHTML={getMarkup(label)}
                            />

                            <div className="checkbox-for-edit-assessment__options">
                                <div className="checkbox-for-edit-assessment__options-container">
                                    {options &&
                                        options.length > 0 &&
                                        options.map((option, index) => {
                                            const optionId = `btn-${question.questionId}-${option.id}`;
                                            return (
                                                <div
                                                    key={option.id}
                                                    className="checkbox-for-edit-assessment__option-wrapper"
                                                    onMouseEnter={(e) => option.title && handleMouseEnter(e, option.id)}
                                                    onMouseLeave={handleMouseLeave}
                                                >
                                                    <Checkbox.OptionItem
                                                        isChecked={isCheckedCurrentOption(option.id)}
                                                        onClick={(e) =>
                                                            onChangeCheckbox(
                                                                e,
                                                                option.id,
                                                                option.name,
                                                                index,
                                                                option.title,
                                                                option.description
                                                            )
                                                        }
                                                        label={option.name}
                                                        className={`edit-assessment-button edit-assessment-checkbox${
                                                            isCheckedCurrentOption(option?.id) ? ' selected-button' : ''
                                                        } ${disabled && !isCheckedCurrentOption(option?.id) ? ' pointer-none ' : ""}`}
                                                        style={{ pointerEvents: disabled ? 'none' : 'auto' }}
                                                        iconClassName="checkbox-for-edit-assessment__icon"
                                                        disabled={disabled ? (isCheckedCurrentOption(option.id) ? false : true) : shouldCheckboxOptionDisabled(question?.singleSelectAnswerId, question?.answerList, option.id)}
                                                        id={optionId}
                                                    />
                                                    {option.title && tooltipVisible === option.id && (
                                                        <div
                                                            className="checkbox-for-edit-assessment__tooltip"
                                                            style={{
                                                                top: `${tooltipPosition.top}px`,
                                                                left: `${tooltipPosition.left}px`,
                                                                position: 'fixed',
                                                                zIndex: 1000
                                                            }}
                                                        >
                                                            <strong>{option.title}</strong>
                                                            <br />
                                                            {option.description}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                </div>
                                {errorMessage && (
                                    <div className="checkbox-for-edit-assessment__error-message">
                                        This field is required
                                    </div>
                                )}
                                {error && error.questionId === question.questionId && (
                                    <span className="checkbox-for-edit-assessment__error-text">
                                        * {error.message}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CheckboxForEditAssessment;
